import { Navigate } from 'react-router-dom';

import { setLocalEntrySource } from '@/entities/entrySource';

import { PATHS } from '@/shared/constants/routes/paths';
import { Loader } from '@/shared/ui/Loader';

export const RecordingEntryCapture = () => {
  setLocalEntrySource('recording');

  return (
    <>
      <Loader />
      <Navigate to={PATHS.homepage} replace />
    </>
  );
};
